import { IonToggle } from '@ionic/react';
import { FormattedMessage } from 'react-intl';

export const ParameterToggle: React.FC<{
  title: string;
  name: string;
  disabled?: boolean;
  visible?: boolean;
  checked: boolean;
  onChange: (e: any) => void;
}> = ({ title, name, disabled, visible = true, checked, onChange }) => (
  <li
    className={`py-2 flex justify-between items-center ${
      visible ? '' : 'hidden'
    }`}
  >
    <div className="flex items-center">
      <p className="text-black">
        <FormattedMessage id={title} />
      </p>
    </div>
    <IonToggle
      name={name}
      checked={checked}
      color="primary"
      onIonChange={(e) => {
        if (e.detail.value) {
          onChange(e);
        }
      }}
      disabled={disabled ? disabled : false}
    />
  </li>
);
